import { useNavigate } from 'react-router-dom';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { PageAbsolutePath } from '../../../consts/Common';
import { useContext } from 'react';
import { SiteContext } from '../../../context/SiteContext';

interface Props {
  responseFlag: boolean;
  customerName: string;
}

const UpdatePreferencesResponse = ({ responseFlag, customerName }: Props) => {
  const navigate = useNavigate();
  const { site } = useContext(SiteContext);

  const onClickGoHome = () => {
    navigate(PageAbsolutePath.Insurance.Landing);
  };

  return (
    <>
      <div className='table-flex-layout'>
        <div className='one-col'>
          {responseFlag ? (
            <div>
              <h4 className='section-header'>Thank you {customerName}</h4>
              <p>Your preferences have been updated.</p>
            </div>
          ) : (
            <div>
              <h4 className='section-header'>Preference update failed</h4>
              <p className='p2'>
                Please contact our customer services team on{' '}
                {site.brand.brandPhoneNumbers.quotesAndRenewalsNumber} for
                assistance
              </p>
            </div>
          )}
        </div>
        <div className='flex-row form-nav'>
          <ButtonBack
            name='btnGoHome'
            text='Go Home'
            onClick={onClickGoHome}
            additionalClassNames='btn-back'
          />
        </div>
      </div>
    </>
  );
};

export default UpdatePreferencesResponse;
